/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Wh_Before_AfterInputs */

const en_cargos_wh_before_after = /** @type {(inputs: Cargos_Wh_Before_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WH (Before → After)`)
};

const es_cargos_wh_before_after = /** @type {(inputs: Cargos_Wh_Before_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacen (Antes → Despues)`)
};

/**
* | output |
* | --- |
* | "WH (Before → After)" |
*
* @param {Cargos_Wh_Before_AfterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_wh_before_after = /** @type {((inputs?: Cargos_Wh_Before_AfterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Wh_Before_AfterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_wh_before_after(inputs)
	return es_cargos_wh_before_after(inputs)
});